import React from 'react'
import styled from 'styled-components'
import { useAuth } from '../../auth/useAuth'
import { Content } from './content'

export const WelcomeBar = () => {
  const { user } = useAuth()

  return (
    <Root>
      <StyledContent variant='narrow'>
        <WelcomeText>
          👋 Welcome {user.name}! Let’s set up your account.
        </WelcomeText>
      </StyledContent>
    </Root>
  )
}

const Root = styled.div`
  height: 60px;
  width: 100%;
  background: #473b4c;
`

const StyledContent = styled(Content)`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  height: 100%;
`

const WelcomeText = styled.p`
  font-weight: bold;
  font-size: 15px;
  line-height: 16px;
  color: #ffffff;
`
